import { render, staticRenderFns } from "./ComWindow.vue?vue&type=template&id=7e472c26"
import script from "./ComWindow.vue?vue&type=script&lang=js"
export * from "./ComWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports